import { render, staticRenderFns } from "./TripOverviewMobile.vue?vue&type=template&id=278cb23c&scoped=true&"
import script from "./TripOverviewMobile.vue?vue&type=script&lang=js&"
export * from "./TripOverviewMobile.vue?vue&type=script&lang=js&"
import style0 from "./TripOverviewMobile.vue?vue&type=style&index=0&id=278cb23c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278cb23c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('278cb23c')) {
      api.createRecord('278cb23c', component.options)
    } else {
      api.reload('278cb23c', component.options)
    }
    module.hot.accept("./TripOverviewMobile.vue?vue&type=template&id=278cb23c&scoped=true&", function () {
      api.rerender('278cb23c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages-mobile/Trips/TripOverviewMobile.vue"
export default component.exports